
import {map, distinctUntilChanged} from 'rxjs/operators';
import { Component, OnInit, Input, HostBinding, forwardRef, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { OxeModelService } from '../oxe-model-service/oxe-model.service';
import { Attribute } from '../attribute/Attribute';




import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'wbm-config-filter-attribute-polymorph',
  templateUrl: './config-filter-attribute-polymorph.component.html',
  styleUrls: ['../../assets/theme/css/attribute.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConfigFilterAttributePolymorphComponent),
      multi: true
    }
  ]
})
export class ConfigFilterAttributePolymorphComponent implements OnInit, ControlValueAccessor {
  @HostBinding() class = 'flex-container nowrap flex-item-fluid bfc';

  @Input()
  filterableAttributes: Array<Attribute>;

  @Output()
  inputModified = new EventEmitter<Object>();

  private _attributeStructureType: Object;
  private JSONLogicOperatorsForAttributeType: Array<string>;
  private _valueChange: BehaviorSubject<any>;

  private name: string;
  private operator: string;
  private value: any;

  private nodeSortOnTranslatedStrings(a: string, b: string): number {
    this._translate.get(a).subscribe((translatedString) => a = translatedString.toLowerCase());
    this._translate.get(b).subscribe((translatedString) => b = translatedString.toLowerCase());
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  }

  private propagateChange = (_: any) => { };

  get attributeStructureType(): Object {
    return this._attributeStructureType;
  }

  get attributeNames(): string[] {
    if (!this.filterableAttributes) {
      return [];
    } else {
      return this.filterableAttributes.map(attribute => attribute.name).sort(this.nodeSortOnTranslatedStrings.bind(this));
    }
  }

  get attributeStructureTypeValues(): string[] {
    if (!this.attributeStructureType || !this.attributeStructureType['values']) {
      return [];
    } else {
      return this.attributeStructureType['values'].sort(this.nodeSortOnTranslatedStrings.bind(this));
    }
  }

  constructor(private _oxeModel: OxeModelService, private _translate: TranslateService) { }

  ngOnInit() {
  }

  writeValue(value: any) {
    this.operator = Object.keys(value)[0];
    if (this.operator) {
      this.name = value[this.operator][0]['var'];

      const attribute = this.getAttributeByName(this.name);
      this._attributeStructureType = attribute.structure['type'];
      let defaultValue = attribute.defaultValue;
       if(attribute.defaultValue === undefined) {
               defaultValue = "";
        }
      this.JSONLogicOperatorsForAttributeType = this._oxeModel.getJSONLogicOperatorsForAttributeType(this._attributeStructureType['name']);
      this._valueChange = new BehaviorSubject(defaultValue);
      this._valueChange.asObservable().pipe(
        distinctUntilChanged(),
        map(val => this.value = val),)
        .subscribe(this.onChange.bind(this));
    }
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched() { }

  onAttributeChange(attributeName: string) {
    this.name = attributeName;
    let defaultValue = '';
    const attribute = this.getAttributeByName(attributeName);
    this._attributeStructureType = attribute.structure['type'];
    this.JSONLogicOperatorsForAttributeType = this._oxeModel.getJSONLogicOperatorsForAttributeType(this._attributeStructureType['name']);
    this.operator = this.JSONLogicOperatorsForAttributeType[0];
    if (attribute.isBoolean) {
      defaultValue = "false";
    } else {
      defaultValue = (!!attribute.defaultValue || attribute.defaultValue === 0) ? attribute.defaultValue : '';
    }

    this._valueChange.next(defaultValue);
    this.onChange();
    this.inputModified.emit({ name: this.name, operator: this.operator, value: defaultValue, enabled: false, resetSortOrder: true });
  }

  private getAttributeByName(attriName: string): Attribute {
    return this.filterableAttributes.find((attr) => attr.name === attriName);
  }

  onOperatorChange(operator: string) {
    this.operator = operator;
    this.onChange();
    this.inputModified.emit({ name: this.name, operator: this.operator, value: this.value, enabled: true });
  }

  onValueChange(elem: any) {
    let elemValue;
    switch (elem.type) {
      case 'number':
        elemValue = elem.valueAsNumber;
        this._valueChange.next(elemValue);
        break;
      case 'checkbox':
        elemValue = elem.checked;
        this._valueChange.next(elemValue);
        break;
      default:
        elemValue = elem.value;
        this._valueChange.next(elemValue);
        break;
    }
    this.inputModified.emit({ name: this.name, operator: this.operator, value: elemValue, enabled: true });
  }

  onChange() {
    let newFilter = {};
    let newValue = this.value;
    if (this.attributeStructureType['name'] === 'Octet_String' || this.attributeStructureType['name'] === 'Sequence' || this.attributeStructureType['name'] === 'Set_Of') {
      // remove accents from string and convert to lowercase for filtering comparisons
      newValue = Attribute.removeDiacritics(newValue).toLowerCase();
    }
    newFilter[this.operator] = [{ 'var': this.name }, newValue];
    this.propagateChange(newFilter);
  }
}
